import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppWidget } from "./components/WhatsAppWidget";
import { GoogleAnalytics } from "./components/GoogleAnalytics";
import { GoogleSearchConsole } from "./components/GoogleSearchConsole";
import { Toaster } from "./components/ui/sonner";
import { Home } from "./pages/Home";
import { AboutUs } from "./pages/AboutUs";
import { Services } from "./pages/Services";
import { IntelligentHeating } from "./pages/IntelligentHeating";
import { DesignTechnical } from "./pages/DesignTechnical";
import { SmartPlumbing } from "./pages/SmartPlumbing";
import { Maintenance } from "./pages/Maintenance";
import { Commercial } from "./pages/Commercial";
import { Gallery } from "./pages/Gallery";
import { Contact } from "./pages/Contact";
import { SystemsDesign } from "./pages/SystemsDesign";
import { Recruitment } from "./pages/Recruitment";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <GoogleSearchConsole />
          <GoogleAnalytics />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/intelligent-heating" element={<IntelligentHeating />} />
            <Route path="/design-technical" element={<DesignTechnical />} />
            <Route path="/smart-plumbing" element={<SmartPlumbing />} />
            <Route path="/systems-design" element={<SystemsDesign />} />
            <Route path="/maintenance-contracts" element={<Maintenance />} />
            <Route path="/commercial" element={<Commercial />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/recruitment" element={<Recruitment />} />
          </Routes>
          <Footer />
          <WhatsAppWidget />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
